import cn from "classnames";
import { formatNumber } from "helpers/system";
import React from "react";

export default function EveryWeekStatistic(props) {
    const { data } = props;

    const renderDataTable = (tableData) => {
        return (
            <div>
                <table className="a-report__table">
                    <thead>
                        <tr>
                            <th className="a-report__table--noborder-left a-report__table--noborder-top">
                                По компании
                            </th>
                            {data.header.map((item, i, arr) => {
                                const isLast = arr.length - 1 === i;
                                return (
                                    <th
                                        key={i}
                                        className={cn("a-report__table--noborder-top", {
                                            "a-report__table--noborder-right font-weight-bold": isLast,
                                        })}
                                    >
                                        {item.week}
                                        <br />
                                        <small className={isLast ? "font-weight-bold" : ""}>{item.period}</small>
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="a-report__table--noborder-left">Количество ТС</td>
                            {tableData.carsCount.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td className="a-report__table--noborder-left">Активный пробег, км</td>
                            {tableData.activeMileage.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td className="a-report__table--noborder-left">Общий пробег, км</td>
                            {tableData.overallMileage.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td className="a-report__table--noborder-left">Вал, руб</td>
                            {tableData.bidsPrice.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td className="a-report__table--noborder-left">Руб/км</td>
                            {tableData.outputPerKm.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td className="a-report__table--noborder-left">Руб/час</td>
                            {tableData.outputPerHour.map((item, i, arr) => (
                                <td key={i} className={arr.length - 1 === i ? "a-report__table--noborder-right" : ""}>
                                    {item.value}
                                    {!!item.percent && (
                                        <>
                                            <br />
                                            <small
                                                className={
                                                    item.percent < 0 ? "a-report__table--red" : "a-report__table--green"
                                                }
                                            >
                                                (
                                                {formatNumber(item.percent / 100, {
                                                    style: "percent",
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                                )
                                            </small>
                                        </>
                                    )}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="pb-2">
            <div className="a-report__text-block">
                <div className="a-report__title">Динамика изменения ключевых показателей парка</div>
                <div className="pb-2">
                    Период: <strong>Неделя {data.week}</strong>
                </div>
                <div className="pb-2">
                    Компания: <strong>{data.organizationName}</strong>
                </div>
                <div className="pb-2">
                    Временной охват: <strong>4 последние недели</strong>
                </div>
            </div>
            <br />
            <div className="a-report__text-block">
                <div className="font-size-18 font-weight-bold pb-2">Обращаем ваше внимание!</div>
                <div className="pb-3">
                    Представленная информация актуальна на момент отправки данного сообщения и формируется на основе
                    данных из &quot;Общего отчета&quot;.
                </div>
                <div>На корректность данных влияют:</div>
                <div>
                    <ul>
                        <li>
                            <strong>Своевременное создание заявок:</strong> необходимо формировать заявки до начала
                            выполнения рейса
                        </li>
                        <li>
                            <strong>Корректное закрытие рейсов:</strong> важно указывать точные адреса пунктов загрузки
                            и выгрузки
                        </li>
                        <li>
                            <strong>Работа GPS-трекеров:</strong> необходима их корректная работа и своевременная
                            актуализация данных
                        </li>
                    </ul>
                </div>
                <div className="text-muted">
                    Соблюдение этих рекомендаций позволит получать наиболее точные и актуальные данные в наших отчетах.
                </div>
            </div>
            <br />
            <div className="a-report__text-block no-page-break">
                <div className="a-report__text-link pb-3 font-size-18">По компании</div>
                {renderDataTable(data.mainData)}
            </div>
            <br />
            {data.logistsData.map((logistData, i) => (
                <div key={i} className="a-report__text-block no-page-break mb-3">
                    {i === 0 && <div className="a-report__text-link pb-3 font-size-18">По группам</div>}
                    <div>
                        <div className="font-weight-bold pb-1">{logistData.key}</div>
                        {renderDataTable(logistData.value)}
                    </div>
                </div>
            ))}
        </div>
    );
}
